<template>
  <div>
    <li class="title">
      <span>网页title设置：{{ title }}</span>
      <el-button type="primary" size="mini" @click="editSummary(title, 0, 500)"
        >编辑</el-button
      >
    </li>

    <div class="modular">
      <h2>banner编辑</h2>
      <div class="modular_wrap">
        <div class="upload-item">
          <li class="upload-title">页头banner位</li>
          <div class="upload-img">
            <img
              v-if="advert01.imageUrl"
              :src="$utils.fileUrl(advert01.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：1200*140</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(advert01, 1)"
              >更改</el-button
            >
          </div>
        </div>
      </div>
      <div class="modular_wrap">
        <div class="upload-item">
          <li class="upload-title">右侧banner位</li>
          <div class="upload-img">
            <img
              v-if="advert02.imageUrl"
              :src="$utils.fileUrl(advert02.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：350*210</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(advert02, 2)"
              >更改</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 广告 -->
    <el-dialog
      v-model="advert_dialog"
      title="编辑广告"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="advertForm"
          :rules="advertRules"
          size="mini"
          ref="advertForm"
          label-width="80px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <label
              class="upload-advert"
              for="file"
              :style="
                advertForm.imageUrl
                  ? `background-image: url(${$utils.fileUrl(
                      advertForm.imageUrl
                    )})`
                  : ''
              "
            >
              <i class="el-icon-plus" v-if="!advertForm.imageUrl"></i>
              <input type="file" id="file" @change="upload($event)" />
            </label>
          </el-form-item>
          <el-form-item
            label="链接："
            prop="imageLink"
          >
            <el-input
              placeholder="链接"
              v-model="advertForm.imageLink"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input
              rows="5"
              resize="none"
              type="textarea"
              placeholder="简介"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageExplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="advert_dialog = false" size="mini">取消</el-button>
          <el-button @click="submit_advert" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      loading: false,
      advert_dialog: false,
      advertForm: {
        id: "",
        imageUrl: "",
        imageExplain: "",
        imageLink: "",
        pageLocation: null,
      },
      advertRules: {
        imageUrl: [
          { required: true, message: "请选择图片", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
      advert01: {},
      advert02: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取所有数据
    async getData() {
      try {
        const res = await this.$api.pageManage.getData(23);
        if (res.code === 10200) {
          this.title = res.data.webTitle.content;
          this.advert01 = res.data.advert01;
          this.advert02 = res.data.advert02;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    // 编辑概述
    editSummary(content, type, limit = 30) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > limit) return `最多输入${limit}个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          this.setSummary({
            content: value,
            pageType: 23,
            pageLocation: type,
          });
        })
        .catch(() => {});
    },
    // 保存概述
    async setSummary(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setSummary(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    // 广告更改按钮
    editAdver(data, type) {
      this.advertForm.imageUrl = data.imageUrl;
      this.advertForm.imageLink = data.imageLink;
      this.advertForm.imageExplain = data.imageExplain;
      this.advertForm.pageLocation = type;
      this.advert_dialog = true;
    },
    upload(e) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png", "svg"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile(5, files)
          .then((res) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.$message.success("上传成功");
            this.advertForm.imageUrl = res;
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    submit_advert() {
      this.$refs["advertForm"].validate((valid) => {
        if (valid) {
          const params = {
            imageUrl: this.advertForm.imageUrl,
            imageExplain: this.advertForm.imageExplain,
            imageLink: this.advertForm.imageLink,
            pageLocation: this.advertForm.pageLocation,
            pageType: 23,
          };
          this.set_advert(params);
        } else {
          return false;
        }
      });
    },
    // 提交编辑广告
    async set_advert(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setAdvert(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.advert_dialog = false;
            this.getData();
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 0.875rem;
  margin-bottom: 10px;
  padding: 15px;
  background-color: #ffffff;

  .el-button {
    margin-left: 20px;
  }
}

.modular {
  padding: 24px;
  margin-bottom: 24px;
  background-color: #ffffff;

  h2 {
    margin-bottom: 20px;
    font-size: 1.125rem;
  }

  .modular_wrap {
    display: flex;

    & + .modular_wrap {
      margin-top: 40px;
    }

    .upload-item {
      width: 180px;

      & + .upload-item {
        margin-left: 60px;
      }

      .upload-title {
        height: 24px;
        line-height: 24px;
        font-size: 0.875rem;

        em {
          color: $--color-danger;
        }
      }

      .tips {
        line-height: 24px;
        font-size: 0.75rem;
        color: $--color-text-secondary;
      }

      .upload-img {
        width: 180px;
        height: 70px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .but {
        display: flex;
        .el-button {
          width: 80px;

          & + .el-button {
            margin-left: auto;
          }
        }

        input[type="file"] {
          display: none;
        }
      }

      &[class*="add"] {
        .upload-img {
          cursor: pointer;
          line-height: 70px;
          text-align: center;
          border: 1px solid $--border-color-base;

          i {
            font-size: 1.5rem;
            color: $--border-color-base;
          }
        }
      }
    }
  }
}


.upload-advert {
  width: 100px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid $--border-color-base;
  input {
    display: none;
  }
}

</style>